import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconTable = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5 3.75C3.48122 3.75 2.25 4.98122 2.25 6.5V17.5C2.25 19.0188 3.48122 20.25 5 20.25H18C20.0711 20.25 21.75 18.5711 21.75 16.5V6.5C21.75 4.98122 20.5188 3.75 19 3.75H5ZM3.75 6.5C3.75 5.80964 4.30964 5.25 5 5.25H6.75V7.75H3.75V6.5ZM3.75 9.25V17.5C3.75 18.1904 4.30964 18.75 5 18.75H6.75V9.25H3.75ZM8.25 18.75H18C19.2426 18.75 20.25 17.7426 20.25 16.5V9.25H8.25V18.75ZM20.25 7.75V6.5C20.25 5.80964 19.6904 5.25 19 5.25H8.25V7.75H20.25Z",
		fill: "currentColor"
	})
});
export { SvgIconTable as ReactComponent };
